/* eslint-disable no-use-before-define */
import {
    arrayFrom, cleanObject, track,
    INV_TYPE_LABELS,
    CORP_SECTOR_LABELS,
    CORP_DEBT_RANK_LABELS,
    MUNI_ENVIRONMENTAL_LABELS,
    AGENCY_TYPE_LABELS,
    COUPON_FREQUENCY_LABELS,
    COUPON_MONTH_LABELS,
    COUPON_FEATURE_LABELS,
} from './all'

export const trackSearch = (name, sp, isAdvanced=false) => {
    let a = getData(sp, isAdvanced)
    track(name, a)
}

const getData = (sp={}, isAdvanced) => {
    let p = {}
    p.securities = wrap(arrayFrom(sp.holdInvType).map(a => INV_TYPE_LABELS[a]))

    p.issuer = wrap(arrayFrom(sp.holdIssue))
    p.cusip = wrap(arrayFrom(sp.holdCusip))

    // corporates
    p.sector = wrap(arrayFrom(sp.holdCorpSectorCode).map(a => CORP_SECTOR_LABELS[a]))
    p.corp_type = wrap(arrayFrom(sp.holdConvertible).map(a => CONVERTIBLE_LABELS[a]))
    p.debt_ranking = wrap(arrayFrom(sp.holdDrnk).map(a => CORP_DEBT_RANK_LABELS[a]))
    p.market_type = wrap(arrayFrom(sp.primarySecondary).map(a => MARKET_TYPES[a]))
    p.symbol = wrap(arrayFrom(sp.holdSymbol))

    // municipals
    p.state = wrap(arrayFrom(sp.holdState))
    p.category = wrap(arrayFrom(sp.holdMuniType)
        .concat(arrayFrom(sp.holdRefundInd))
        .concat(arrayFrom(sp.holdRefundType))
        .map(a => CATEGORY_LABELS[a]))
     p.tax_treatment = wrap(arrayFrom(sp.holdTaxable).map(a => FEDERAL_TAX_LABELS[a])
        .concat(arrayFrom(sp.holdStateTaxExempt).map(a => STATE_TAX_LABELS[a]))
        .concat(arrayFrom(sp.holdAltMinTax).map(a => AMT_TAX_LABELS[a])))
    p.use_of_proceeds = wrap(arrayFrom(sp.holdUseOfProceeds))
    p.environmental = wrap(arrayFrom(sp.holdIssueType).map(a => MUNI_ENVIRONMENTAL_LABELS[a]))
    p.deminimis = wrap(arrayFrom(sp.offeringDeMinStatus))
    if (sp.holdInsurance) p.insured = arrayFrom(sp.holdInsurance).length > 0

    // cds
    p.bluesky_state = wrap(arrayFrom(sp.holdBlueSkyStateCD))
    p.fdic = sp.holdFdicNum

    // agencies
    p.agency = wrap(arrayFrom(sp.holdAgencyType).map(a => AGENCY_TYPE_LABELS[a]))

    // treasuries
    p.ust_type = wrap(arrayFrom(sp.holdTreasuryType))

    // common fields
    p.maturity_min = sp.holdMaturityMin
    p.maturity_max = sp.holdMaturityMax

    p.rating = RATING_LABELS[sp.rating]
    p.moody_credit_rating_min = sp.holdMoodyRatingMin
    p.moody_credit_rating_max = sp.holdMoodyRatingMax
    p.sp_credit_rating_min = sp.holdSpRatingMin
    p.sp_credit_rating_max = sp.holdSpRatingMax

    p.price_min = sp.clientPriceMin
    p.price_max = sp.clientPriceMax
    p.quantity_min = sp.quantityMin
    p.quantity_max = sp.quantityMax

    p.yield_to_worst_min = sp.ytwMin
    p.yield_to_worst_max = sp.ytwMax
    p.yield_to_maturity_min = sp.ytmMin
    p.yield_to_maturity_max = sp.ytmMax

    p.coupon_min = sp.holdCouponMin
    p.coupon_max = sp.holdCouponMax
    p.coupon_frequeny = wrap(arrayFrom(sp.holdCouponPayFrequency).map(a => COUPON_FREQUENCY_LABELS[a]))
    p.coupon_pay_month = wrap(arrayFrom(sp.holdCouponPayMonths).map(a => COUPON_MONTH_LABELS[a]))
    p.coupon_features = wrap(arrayFrom(sp.holdCouponTypeCode).map(a => COUPON_FEATURE_LABELS[a]))

    p.call_features = wrap(arrayFrom(sp.holdCallableInd).map(a => CALLABLE_LABELS[a])
        .concat(arrayFrom(sp.holdWholeCallInd).map(a => MAKE_WHOELE_CALL_LABELS[a])))

    p.put_features = wrap(arrayFrom(sp.holdPutableInd)
        .concat(arrayFrom(sp.holdPutType))
        .map(a => PUTTABLE_LABELS[a]))

    p.other_features = wrap(arrayFrom(sp.holdNextSink).map(a => SINK_LABELS[a])
        .concat(arrayFrom(sp.holdErpInd).map(a => ERP_LABELS[a])))

    p.next_call_min = sp.holdFirstCallMin
    p.next_call_max = sp.holdFirstCallMax

    if (isAdvanced) {
        p.offering_posted = sp.offeringNewToday ? 'New Today' : 'Any Time'

        let {field, direction} = arrayFrom(sp.sort)[0]
        p.sort_by = SORT_BY_LABELS[field]
        p.sort_order = SORT_ORDER_LABELS[direction]
        p.results_per_page = sp.resultsPerPage
    }

    return cleanObject(p)
}

const wrap = (arr) => arr.filter(Boolean).join('|')

const CONVERTIBLE_LABELS = {
    'Y': 'Convertible',
    'N': 'Non-Convertible',
}

const MARKET_TYPES = {
    'primary': 'New Issue',
    'secondary': 'Secondary',
}

const CATEGORY_LABELS = {
    'G': 'General Obligation',
    'R': 'Revenue',
    'Y': 'Refunded',
    'PRE': 'Pre-Refunded',
    'ETM': 'Escrowed To Maturity',
}

const FEDERAL_TAX_LABELS = {
    'BAB': 'Build America Bonds',
    'Y': 'Federally Taxable',
    'N': 'Federally Tax-Exempt',
}

const STATE_TAX_LABELS = {
    'Y': 'State Taxable',
    'N': 'State Tax-Exempt',
}

const AMT_TAX_LABELS = {
    'Y': 'Subject to AMT',
    'N': 'Exempt from AMT',
}

const RATING_LABELS = {
    'high-yield': 'High Yield',
    'investment-grade': 'Investment Grade',
}

const CALLABLE_LABELS = {
    'Y': 'Callable',
    'N': 'Non-Callable',
}

const MAKE_WHOELE_CALL_LABELS = {
    'Y': 'Make Whole Call',
}

const PUTTABLE_LABELS = {
    'Y': 'Puttable',
    'N': 'Non-Puttable',
    'MAN': 'Mandatory',
    'COND': 'Conditional',
    'SUR': 'Survivor',
}

const SINK_LABELS = {
    'Y': 'Sinking Fund',
    'N': 'No Sinking Fund',
}

const ERP_LABELS = {
    'Y': 'Extraordinary Redemption Provision',
    'N': 'Non-Extraordinary Redemption Provision'
}

const SORT_BY_LABELS = Object.fromEntries([
    {label:'Quantity', value:'askQuantity'},
    {label:'Issuer', value:'holdIssue'},
    {label:'Coupon', value:'holdCoupon'},
    {label:'Maturity', value:'holdMaturitySortDt'},
    {label:'Price', value:'askPrice'},
    {label:'Yield to worst', value:'askYield'},
    {label:'Yield to maturity', value:'askYieldmat'}
].map(({label,value}) => [value, label]))

const SORT_ORDER_LABELS = {
    'ASC': 'Ascending',
    'DESC': 'Descending',
}
